<template>
  <div>
    <!-- Product Details Dialog -->
    <md-dialog :md-active.sync="product_details_dialog.show">
      <md-dialog-title>
        <div v-if="assessmentType !== 'ram'">
          Product Details ({{
            product_details_dialog.product && product_details_dialog.product.lender_name
          }}: {{ product_details_dialog.product && product_details_dialog.product.product_name }})
        </div>
        <div v-else>
          Product Details ({{
            product_details_dialog.product && product_details_dialog.product.lender_name
          }}: {{ product_details_dialog.product && product_details_dialog.product.product_grade_name }})
        </div>
      </md-dialog-title>

      <div class="md-layout input-layout">
        <div class="md-layout-item md-size-25">
          <property-view v-if="toShowProp('type')" name="Type" right>
            {{ product_details_dialog.product && product_details_dialog.product.type }}
          </property-view>
          <property-view v-if="toShowProp('product')" name="Lender" right>
            {{ product_details_dialog.product && product_details_dialog.product.lender_name }}
          </property-view>
          <property-view v-if="toShowProp('product')" name="Grade" right>
            <div v-if="assessmentType !== 'ram'">
              {{ product_details_dialog.product && product_details_dialog.product.product_name }}
            </div>
            <div v-else>
              {{ product_details_dialog.product && product_details_dialog.product.product_grade_name }}
            </div>
          </property-view>
          <property-view v-if="toShowProp('approval_rate')" name="Approval Rate" right>
            {{ product_details_dialog.product && product_details_dialog.product.approval_rate }}
          </property-view>
          <property-view
            v-if="toShowProp('requires_bankstatements')"
            name="Require Bankstatements"
            right
          >
            {{
              product_details_dialog.product &&
              product_details_dialog.product.requires_bankstatements | bankstatements(assessmentType)
            }}
          </property-view>
          <property-view v-if="toShowProp('asset_age_max')" name="Max Asset Age" right>
            {{
              product_details_dialog.product &&
              product_details_dialog.product.asset_age_max | round | suffix("y")
            }}
          </property-view>
          <property-view v-if="toShowProp('term')" name="Min Term" right>
            {{
              product_details_dialog.product &&
              product_details_dialog.product.term_min | round | suffix("m")
            }}
          </property-view>
          <property-view v-if="toShowProp('term')" name="Max Term" right>
            {{
              product_details_dialog.product &&
              product_details_dialog.product.term_max | round | suffix("m")
            }}
          </property-view>
        </div>
        <div class="md-layout-item md-size-25">
          <property-view v-if="toShowProp('ltv_max')" name="Max LTV" right>
            {{
              product_details_dialog.product && product_details_dialog.product.ltv_max | round(2)
            }}
          </property-view>
          <property-view v-if="toShowProp('amount_max')" name="Max Lend" right>
            {{
              product_details_dialog.product &&
              product_details_dialog.product.amount_max | currency(0)
            }}
          </property-view>
          <property-view v-if="toShowProp('rate')" name="Base Rate" right>
            {{
              product_details_dialog.product &&
              product_details_dialog.product.rate_min | percentage(2, false)
            }}
          </property-view>
          <property-view v-if="toShowProp('rate')" name="Retail Rate" right>
            {{
              product_details_dialog.product &&
              product_details_dialog.product.rate_max | percentage(2, false)
            }}
          </property-view>
          <property-view v-if="toShowProp('payments_min')" name="Min Monthly Payments" right>
            {{
              product_details_dialog.product &&
              product_details_dialog.product.payments_min | currency
            }}
          </property-view>
          <property-view v-if="toShowProp('broker_fee')" name="Broker Fee" right>
            {{
              product_details_dialog.product &&
              product_details_dialog.product.broker_fee | currencyOrPercentage
            }}
          </property-view>
          <property-view v-if="toShowProp('commission')" name="Commission" right>
            {{
              product_details_dialog.product &&
              product_details_dialog.product.commission | currencyOrPercentage
            }}
          </property-view>
          <property-view v-if="toShowProp('total_income')" name="Total Income" right>
            {{
              product_details_dialog.product &&
              product_details_dialog.product.total_income | currency
            }}
          </property-view>
        </div>

        <div
          v-if="product_details_dialog.product && product_details_dialog.product.notes.length > 0"
          class="md-layout-item md-size-50"
        >
          <div
            v-for="{ status, description } in product_details_dialog.product.notes"
            :key="description"
          >
            <note-view :status="status">{{ description }}</note-view>
          </div>
          <div v-if="loanType === 'Consumer' && product_details_dialog.product && product_details_dialog.product.payments_min > application.loan.capacity_and_prelim.uncommited_income" class="uncommitted-warning">
            <md-icon class="md-icon md-alignment-center orange-icon">warning</md-icon>
            <span>This repayment is not serviceable based on current application details. A reduced lend or discounted rate may be required</span>
          </div>
        </div>
        <div
          v-if="!oneScoreLabel"
        >
          <div v-if="lender_list.includes(product_details_dialog.product && product_details_dialog.product.lender_name)"
               class="md-layout-item md-size-100 text-danger blink_me">
            Due to missing one score data, please quote rate for correct tier in
            {{ product_details_dialog.product && product_details_dialog.product.lender_name }} system prior to
            submission.
          </div>
        </div>
        <div v-if="ammf.includes(product_details_dialog.product && product_details_dialog.product.lender_name)"
             class="md-layout-item md-size-100 text-danger blink_me">
          Please Note Non LTV booking vessels can be work shopped with AMMF
        </div>
      </div>

      <md-dialog-actions>
        <md-button class="md-primary md-simple" @click="hideProductDetailsDialog()">
          Close
        </md-button>
        <md-button class="md-primary" @click="selectProduct(product_details_dialog.product)">
          Select
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="selected_product_dialog.show">
      <md-dialog-title>
        Product Details ({{
          selected_product_dialog.product && selected_product_dialog.product.lender_name
        }}: {{ selected_product_dialog.product && selected_product_dialog.product.product_name }})
      </md-dialog-title>
      <div v-if="!oneScoreLabel" class="md-layout input-layout">
        <div v-if="lender_list.includes(selected_product_dialog.product && selected_product_dialog.product.lender_name)"
             class="md-layout-item md-size-100 text-danger">
          Due to missing one score data, please quote rate for correct tier in
          {{ selected_product_dialog.product && selected_product_dialog.product.lender_name }} system prior to
          submission.
        </div>
      </div>
      <div v-if="ammf.includes(selected_product_dialog.product && selected_product_dialog.product.lender_name)"
           class="md-layout-item md-size-100 text-danger">
        Please Note Non LTV booking vessels can be work shopped with AMMF
      </div>
      <md-dialog-actions>
        <md-button class="md-primary md-simple" @click="hideSelectedProductDialog()">
          Close
        </md-button>
        <md-button class="md-primary"
                   @click="selectProduct(selected_product_dialog.product); hideSelectedProductDialog()">
          Ok
        </md-button>
      </md-dialog-actions>
    </md-dialog>
    <!-- Product Options Table -->
    <group-card :disabled="disableProductTable()" icon="list" title="Options">
      <div v-if="needToShowVehicleWarning()">
        <p class="vehicle-warning">
          Lender Recommendations are based on a {{ application.loan.asset.vehicle.model_year }} used vehicle
          - for other scenarios provide year, make and model and re-run the assessment.
        </p>
      </div>
      <div
        v-if="assessment"
      >
        <md-radio
          v-if="this.showCarbonRecommendation && assessment.top_recommendations && assessment.top_recommendations.length > 0"
          v-model="radio_button"
          value="top_recommendations"
        >
          Carbon Recommendation
        </md-radio>
        <md-radio
          v-if="this.showHighestAccuracyRate && assessment.highest_approval_rate_products && assessment.highest_approval_rate_products.length > 0"
          v-model="radio_button"
          value="highest_accuracy"
        >
          Highest Accuracy Rate
        </md-radio>
        <md-radio
          v-if="this.showLowestInterestRate && assessment.lower_interest_rate_products && assessment.lower_interest_rate_products.length > 0"
          v-model="radio_button"
          value="lowest_interest"
        >
          Lowest Interest Rate
        </md-radio>
      </div>
      <data-table
        v-model="products"
        :headers="filtered_headers"
        :items-per-page="5"
        @double-click="selectProduct($event)"
      >
        <template v-slot:item.lender_name="{ item }">
          <div v-if="!agent_has_visibility_subscription">
            <md-tooltip md-direction="top">{{ item.lender_name }}</md-tooltip>
            <img :alt="item.lender_name" :src="'/images/lenders/' + item.lender_id + '.png'"/>
          </div>
          <div v-else>
            <p>{{ item.lender_id }}</p>
          </div>
        </template>
        <template v-slot:item.payments_min="{ item }">
          <div class="d-flex">
            <span> {{ item.payments_min | currency }} </span>
            <span v-if="loanType === 'Consumer' && item.payments_min > application.loan.capacity_and_prelim.uncommited_income">
              <md-tooltip> This repayment is not serviceable based on current application details. A reduced lend or discounted rate may be required</md-tooltip>
              <md-icon class="md-icon md-alignment-center orange-icon">warning</md-icon>
            </span>
          </div>
        </template>
        
        <template v-slot:item.actions="{ item }">
          <md-button class="md-icon-button md-primary md-simple"
                     @click="needToShowDialog(item) ? showSelectedProductDialog(item) : selectProduct(item)">
            <md-icon>content_copy</md-icon>
            <md-tooltip md-direction="top">Select</md-tooltip>
          </md-button>
          <md-button
            class="md-icon-button md-primary md-simple"
            @click="showProductDetailsDialog(item)"
          >
            <md-icon>info</md-icon>
            <md-tooltip md-direction="top">Details</md-tooltip>
          </md-button>
        </template>
      </data-table>
    </group-card>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import filters from "@/components/utils/filters";
import ValidatedInputs from "@/components/ValidatedInput";
import GroupCard from "@/components/Cards/GroupCard";
import DataTable from "@/components/DataTable";
import {PropertyView} from "@/components";
import {NoteView} from "@/components";

export default {
  components: {
    ...ValidatedInputs,
    GroupCard,
    DataTable,
    PropertyView,
    NoteView,
  },
  props: {
    value: {
      type: Object,
    },
    zinkCapacityStatus: {
      type: String,
      default: 'good',
    },
    isOneScoreDataExist: {
      type: Boolean,
      default: false,
    },
    assessmentType: {
      type: String,
      default: '',
    },
    loanType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showVehicleWarning: false,
      radio_button: 'highest_accuracy',
      selected_product: null,
      product_details_dialog: {
        show: false,
        product: null,
      },
      selected_product_dialog: {
        show: false,
        product: null,
      },
      toShow: {
        advise_order: {
          personal: {table: true, prop: true},
          consumer: {table: true, prop: true},
          commercial: {table: true, prop: true},
        },
        approval_rate: {
          personal: {table: true, prop: true},
          consumer: {table: true, prop: true},
          commercial: {table: true, prop: true},
        },
        lender_name: {
          personal: {table: true, prop: true},
          consumer: {table: true, prop: true},
          commercial: {table: true, prop: true},
        },
        product_name: {
          personal: {table: true, prop: true},
          consumer: {table: true, prop: true},
          commercial: {table: true, prop: true},
        },
        product: {
          personal: {table: false, prop: true},
          consumer: {table: false, prop: true},
          commercial: {table: false, prop: true},
        },
        product_grade_name: {
          personal: {table: true, prop: true},
          consumer: {table: true, prop: true},
          commercial: {table: true, prop: true},
        },
        loan_type: {
          personal: {table: true, prop: true},
          consumer: {table: true, prop: true},
          commercial: {table: true, prop: true},
        },
        requires_bankstatements: {
          personal: {table: true, prop: true},
          consumer: {table: true, prop: true},
          commercial: {table: true, prop: true},
        },
        ltv_max: {
          personal: {table: false, prop: false},
          consumer: {table: true, prop: true},
          commercial: {table: true, prop: true},
        },
        asset_age_max: {
          personal: {table: false, prop: false},
          consumer: {table: false, prop: true},
          commercial: {table: false, prop: true},
        },
        term: {
          personal: {table: false, prop: true},
          consumer: {table: false, prop: true},
          commercial: {table: false, prop: true},
        },
        term_min: {
          personal: {table: false, prop: true},
          consumer: {table: false, prop: true},
          commercial: {table: false, prop: true},
        },
        term_max: {
          personal: {table: false, prop: true},
          consumer: {table: false, prop: true},
          commercial: {table: false, prop: true},
        },
        amount_max: {
          personal: {table: true, prop: true},
          consumer: {table: true, prop: true},
          commercial: {table: true, prop: true},
        },
        rate: {
          personal: {table: false, prop: true},
          consumer: {table: false, prop: true},
          commercial: {table: false, prop: true},
        },
        rate_min: {
          personal: {table: true, prop: true},
          consumer: {table: true, prop: true},
          commercial: {table: true, prop: true},
        },
        rate_max: {
          personal: {table: true, prop: true},
          consumer: {table: true, prop: true},
          commercial: {table: true, prop: true},
        },
        payments_min: {
          personal: {table: true, prop: true},
          consumer: {table: true, prop: true},
          commercial: {table: true, prop: true},
        },
        broker_fee: {
          personal: {table: true, prop: true},
          consumer: {table: true, prop: true},
          commercial: {table: true, prop: true},
        },
        commission: {
          personal: {table: true, prop: true},
          consumer: {table: true, prop: true},
          commercial: {table: true, prop: true},
        },
        total_income: {
          personal: {table: true, prop: true},
          consumer: {table: true, prop: true},
          commercial: {table: true, prop: true},
        },
        actions: {
          personal: {table: true, prop: false},
          consumer: {table: true, prop: false},
          commercial: {table: true, prop: false},
        },
      },
      lender_list: ['Plenti (Personal Loans)', 'Latitude Auto', 'Latitude Personal Loans', 'Latitude Variable', 'Wisr (Auto)', 'Wisr (Personal)'],
      ammf: ['AMMF (Commercial)', 'AMMF (Consumer)'],
      headers: [
        {
          text: "Advise Order",
          value: "advise_order",
          sort: 0,
        },
        {
          text: "Approval Rate",
          value: "approval_rate",
          sort: 0,
          valueFunction(item) {
            let approval_rate = String(item.approval_rate);
            if (approval_rate === "NA" || approval_rate.includes('%')) {
              return approval_rate;
            } else {
              return filters.percentage(approval_rate, 2, false);
            }
          },
        },
        {
          text: "Lender",
          value: "lender_name",
          sort: false,
        },
        {
          text: "Tier",
          value: "product_name",
          sort: false,
        },
        {
          text: "Product",
          value: "product",
          sort: false,
        },
        {
          text: "Asset Type",
          value: "loan_type",
          sort: false,
          filter: this.capitalizeForAllCase,
        },
        {
          text: "Bank Statements",
          value: "requires_bankstatements",
          sort: 0,
          filter: this.bankstatements,
          filter_args: [this.assessmentType],
        },
        {
          text: "Max LTV",
          value: "ltv_max",
          type: Number,
          sort: 0,
          filter: this.round,
          filter_args: [2],
        },
        {
          text: "Max Asset Age",
          value: "asset_age_max",
          type: Number,
          sort: 0,
          filter: this.round,
        },
        {
          text: "Term",
          value: "term",
          type: Number,
          sort: 0,
          filter: this.round,
        },
        {
          text: "Min Term",
          value: "term_min",
          type: Number,
          sort: 0,
          filter: this.round,
        },
        {
          text: "Max Term",
          value: "term_max",
          type: Number,
          sort: 0,
          filter: this.round,
        },
        {
          text: "Max Lend",
          value: "amount_max",
          type: Number,
          sort: 0,
          filter: this.currency,
          filter_args: [0],
        },
        {
          text: "Rate",
          value: "rate",
          type: Number,
          sort: 0,
          filter: this.percentage,
          filter_args: [2, false],
        },
        {
          text: "Base Rate",
          value: "rate_min",
          type: Number,
          sort: 0,
          filter: this.percentage,
          filter_args: [2, false],
        },
        {
          text: "Max Rate",
          value: "rate_max",
          type: Number,
          sort: 0,
          filter: this.percentage,
          filter_args: [2, false],
        },
        {
          text: "Repayments",
          value: "payments_min",
          type: Number,
          sort: 0,
          filter: this.currency,
          filter_args: [0],
        },
        {
          text: "Broker Fee",
          value: "broker_fee",
          type: Number,
          sort: 0,
          filter: this.currency,
          filter_args: [0],
        },
        {
          text: "Commission",
          value: "commission",
          type: Number,
          sort: 0,
          filter: this.currency,
          valueFunction(item) {
            let commission = item.total_income - item.broker_fee;
            if (commission > 0) {
              return commission;
            }
            return 0;
          },
          filter_args: [0],
        },
        {
          text: "Total Income",
          value: "total_income",
          type: Number,
          sort: 0,
          filter: this.currency,
          filter_args: [0],
        },
        {
          text: "Actions",
          value: "actions",
          sort: false,
        },
      ],
      oneScoreLabel: false,
      showCarbonRecommendation: false,
      showHighestAccuracyRate: true,
      showLowestInterestRate: true,
    };
  },
  computed: {
    ...mapGetters([
      "userHasRole",
      "application",
      "userHasPermission",
      "agent_has_visibility_subscription",
    ]),
    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    assessment: {
      get() {
        return this.value;
      },
      set(assessment) {
        this.$emit("input", assessment);
      },
    },

    products() {
      // bad status does not show any products
      if (!this.assessment || this.zinkCapacityStatus === 'bad') {
        return [];
      }
      const hasBadConsumerCapacityCheck = this.assessment.decision_engines.some(decision_engine =>
        (decision_engine.engine_name === 'Consumer Capacity Check Rules' || decision_engine.engine_name === 'Personal Capacity Check Rules') && decision_engine.status === 'error'
      );

      if (hasBadConsumerCapacityCheck) {
        return [];
      }

      if (this.assessmentType === 'ram') {
        switch (this.radio_button) {
          case 'default':
            return this.assessment.options;
          case 'highest_accuracy':
            return this.assessment.highest_approval_rate_products;
          case 'lowest_interest':
            return this.assessment.lower_interest_rate_products;
          case 'top_recommendations':
            return this.assessment.top_recommendations;
          default:
            return this.assessment.options;
        }
      }

      return this.assessment.options;
    },

    filtered_headers() {
      let headers = this.headers.filter((header) => this.toShowCol(header.value));
      if (this.agent_has_visibility_subscription) {
        headers = headers.filter(header => !["commission", "product_name", "rate_min", "broker_fee", "total_income", "actions", "product"].includes(header.value));
      }
      if (
        this.assessmentType === "ram"
        && (this.radio_button == 'highest_accuracy' || this.radio_button == 'lowest_interest' || this.radio_button == 'top_recommendations')
      ) {
        // Remove sorting apply and reset data with api
        headers.forEach(item => {
          item.sort = 0;
        })
        // remove advise order column
        headers.splice(0, 1);
      }
      return headers;
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,

    selectProduct(product) {
      this.hideProductDetailsDialog();
      this.$emit("select", product, this.assessmentType);
    },
    showProductDetailsDialog(product) {
      this.product_details_dialog.product = product;
      this.product_details_dialog.show = true;
    },
    hideProductDetailsDialog() {
      this.product_details_dialog.show = false;
      this.product_details_dialog.product = null;
    },
    showSelectedProductDialog(product) {
      this.selected_product_dialog.product = product;
      this.selected_product_dialog.show = true;
    },
    hideSelectedProductDialog() {
      this.selected_product_dialog.show = false;
      this.selected_product_dialog.product = null;
    },
    toShowCol(key) {
      return (
        this.assessment &&
        this.assessment.type &&
        this.toShow[key] &&
        this.toShow[key][this.assessment.type].table
      );
    },
    toShowProp(key) {
      return (
        this.assessment &&
        this.assessment.type &&
        this.toShow[key] &&
        this.toShow[key][this.assessment.type].prop
      );
    },
    async checkVehicleInfo() {
      const assetType = this.application.loan.asset.type;
      const previousYear = new Date().getFullYear() - 1;

      if (assetType === "Vehicle") {
        const vehicleYear = this.application.loan.asset.vehicle.model_year;
        const vehicleModel = this.application.loan.asset.vehicle.model;
        const vehicleMake = this.application.loan.asset.vehicle.make;

        // The model year is provided and is not previous year
        if (vehicleYear >= 1900 && vehicleYear < previousYear) {
          this.showVehicleWarning = false;
          return;
        }

        // Show warning if is Vehicle asset, year is provided and model or make is missing
        if ((vehicleYear != 0 && vehicleYear) &&
          (!vehicleMake || !vehicleModel)) {
          this.showVehicleWarning = true;
          return;
        }

        // Save previous year as model Year if not provided
        if (vehicleYear == 0 || !vehicleYear) {
          await axios.post(
            "/api/v1/application/update-vehicle-year",
            {
              year: previousYear,
              loan_id: this.application.loan.id
            }
          ).then(async (res) => {
            this.showVehicleWarning = true;
            Vue.set(this.application.loan.asset.vehicle, 'model_year', previousYear);
            return;
          }).catch((err) => {
            this.showVehicleWarning = false;
            console.log(err.response.data);
          });
        }
      } else {
        this.showVehicleWarning = false;
      }
    },
    currencyOrPercentage(value) {
      return Number(value) < 1 ? this.percentage(value) : this.currency(value);
    },
    bankstatements(value, assessmentType) {
      if (assessmentType == 'ram') {
        return value;
      }

      switch (value) {
        case "Required":
        case "Yes":
          return "Yes";
        case "Not required":
        case "No":
          return "No";
        default:
          return value;
      }
    },
    needToShowDialog(item) {
      return [...this.lender_list, ...this.ammf].includes(item.lender_name)
    },
    needToShowVehicleWarning() {
      return this.assessment && !!this.assessment.options
        && this.assessment.options.length > 0 && this.showVehicleWarning;
    },
    disableProductTable() {
      if (this.assessmentType === 'ram') {
        return !this.assessment || !this.assessment.highest_approval_rate_products
          || !this.assessment.lower_interest_rate_products;
      } else if (this.assessmentType === 'adp') {
        return !this.assessment || !this.assessment.options;
      }
      return true;
    },
    changeHeaderForRam() {
      // change product name to use product_grade_name
      let index = this.headers.findIndex((header) => header.text === 'Tier');
      this.$set(this.headers, index, {
        text: "Tier",
        value: "product_grade_name",
        sort: false,
      });
    }
  },
  mounted() {
    this.checkVehicleInfo();
    if (this.assessmentType === 'ram') {
      this.changeHeaderForRam();
    }

    //Allow Super-Admins OR user with permission to see Carbon Recommendation
    if (this.userHasRole('super-admin') || this.userHasPermission('view carbon-recommendation')) {
      this.showCarbonRecommendation = true;
    }
  },
  watch: {
    "isOneScoreDataExist"(newVal) {
      this.oneScoreLabel = newVal;
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,

    currencyOrPercentage(value) {
      return Number(value) < 1 ? filters.percentage(value) : filters.currency(value);
    },
    bankstatements(value, assessmentType) {
      if (assessmentType == 'ram') {
        return value;
      }

      switch (value) {
        case "Required":
        case "Yes":
          return "Yes";
        case "Not required":
        case "No":
          return "No";
        default:
          return value;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/theme.scss";

.blink_me {
  animation: blinker 2.5s linear infinite;
}

.vehicle-warning {
  text-align: center;
  font-weight: bold;
  color: red;
  font-size: 16px;
}

.orange-icon {
  color: $ausloans-orange !important;
}

.d-flex {
    display: flex;
}

.uncommitted-warning {
  margin-top: 10px;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>
